import React from 'react';
import { Link } from 'react-router-dom';
import ButtonMailto from './ButtonMailto';
import './ContactUs.css';

export interface Props {
  title?: string
  subtitle?: string
  button?: string
}
function ContactUs(props : Props) {
  const openMail = () => {
    window.open(`mailto:info@intimelink.com`);
  }
  return (
    <div className="ContactUs">
      <div className='column-left'>
        <h2>{props.title === null ? "Contact us" : props.title}</h2>
        <p>{props.subtitle === null ? "Lorem" : props.subtitle}</p>
      </div>
      {/* <ButtonMailto></ButtonMailto> */}
      <div className='column-right flex-column'>
      <a href="https://docs.google.com/forms/d/e/1FAIpQLSdgKtt1dl-DD7VNvGyCeMFnp-ZF20WvdYir8rKgfnKXhyJA4w/viewform?usp=sf_link" className= "primary white">Compila il form</a>
      <a href="mailto:info@intimelink.com" className= "mt2 secondary white">Invia una mail</a>
      </div>
      {/* <a onClick={openMail}>info@intimelink.com</a> */}
      {/* <Link to={{ pathname: "mailto:no-reply@example.com" }} target="_blank">s</Link> */}
      {/* <ButtonMailto label="Write me an E-Mail" mailto="mailto:no-reply@example.com" /> */}
        {/* <Link to='#' onClick={(e) => window.location = 'mailto:yourmail@gmail.com'} className='primary white'>{props.button === null ? "Leave a message" : props.button}</Link> */}
        {/* <Link to="/contacts" className='primary white'>{props.button === null ? "Leave a message" : props.button}</Link> */}
    </div>
  );
}

export default ContactUs;
document.getElementById('root')
